/** Default fixed dimensions for the tokenization widget (desktop-first). */
export const TOKENIZATION_WIDGET_DEFAULT_SIZE = {
  width: 1200,
  height: 760,
} as const;
